import SuccessScreen from '../../screens/SuccessScreen'

const Success = () => {
  return <SuccessScreen />
}

export default Success
